// react
import React, { useState, useEffect, useRef } from 'react'

// react router
import { Link } from 'react-router-dom'

// redux
import { connect } from 'react-redux'
// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// STYLES
// bootstrap
import {
	Container,
	Spinner
} from 'react-bootstrap'
// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
	useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// API's
import { getProductsAttributes, cancelGetProductsAttributesApi, addProduct } from 'utlis/Apis/Products_API'
import { getBrands, cancelGetBrandsApi } from 'utlis/Apis/Brands_API'
import { getCategoriesTree, cancelGetCategoriesTreeApi } from 'utlis/Apis/Categories_API'

// components
import PageLeftView from './includes/PageLeftView'
import PageRightView from './includes/PageRightView'
import PageTabsLinks from './includes/PageTabsLinks'

import AddNewVariation from './includes/Variations/AddNewVariation'

// modal
import InfoModal from 'utlis/helpers/Modals/InfoModal'
// app messages
import {
	UNKNOWN_ERROR_OCCURED,
	ERROR_WHILE__NAME,
	PRODUCT_ADDED_SUCCESSFULLY,
	ERROR_WHILE_CREATING_PRODUCT
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'


function CreateProduct(props) {
	// props
	const {
		authState,
		setGlobalLoading,
		match,
		history
	} = props

	// consts
	const allowedMetaTitleLength = 55
	const allowedMetaDescLength = 400

	// store url
    const [storeUrl] = useStoreUrl()

	// refs
	const submitBtnRef = useRef(null)

	// states
	const [pageActiveTab, setPageActiveTab] = useState('general_tab')

	const [productImages, setProductImages] = useState(null)
	const [productImagesToBeSaved, setProductImagesToBeSaved] = useState([])
	const [productAttributes, setProductAttributes] = useState([])
	const [selectedProductsAttributes, setSelectedProductsAttributes] = useState([])


	const [categories, setCategories] = useState([])
	const [selectedCategories, setSelectedCategories] = useState([])
	const [defaultCategories, setDefaultCategories] = useState([])
	const [categoriesToBeSaved, setCategoriesToBeSaved] = useState([])
	const [errorInCategories, setErrorInCategories] = useState(false)

	const [brands, setBrands] = useState([])

	const [variantAllFieldsData, setVariantAllFieldsData] = useState([])
	const [variantMainFields, setVariantMainFields] = useState([])
	const [deletedVariantMainFields, setDeletedVariantMainFields] = useState([])
	const [productCombinations, setProductCombinations] = useState([])
	const [productCombinationsImages, setProductCombinationsImages] = useState([])
	const [disabledVariantList, setDisabledVariantList] = useState([])
	const [addNewVariationViewVisible, setAddNewVariationViewVisible] = useState(false)

	const [ribbonColors, setRibbonColors] = useState(['rgb(252, 167, 38)', 'rgb(243, 90, 102)', 'rgb(112, 145, 218)', 'rgb(78, 205, 196)', 'rgb(199, 88, 199)'])

	const [submitButtonDisable, setSubmitButtonDisable] = useState(false)
	const [submitButtonLoading, setSubmitButtonLoading] = useState(false)

	const [leavethePageModalVisibility, setLeavethePageModalVisibility] = useState(false)

	const todayData = new Date()
	// initial form values
	const initialFormValues = {
		productName: "",
		SKU: "",
		status: true,
		isFeatured: false,
		costPrice: "",
		price: "",
		promoPrice: "",
		longDescription: "",
		shortDescription: "",
		description: "",
		stock: "",
		lowStock: "",
		maxOrderQuantity: "",
		minOrderQuantity: "",
		weight: "",
		width: "",
		length: "",
		brandId: "",
		UPC: "",
		height: "",
		metaTitle: "",
		metaDescription: "",
		attributes: [], // { attributesId: "value", attributesName: "value" }
		hasRibbon: false,
		ribbonText: "",
		ribbonColor: ribbonColors[0],
		ribbonDisableDescription: "",
		ribbonDisableToCart: false,
		ribbonPosition: "on_image", // on_image or under_imaage
		purchasabilityStatus: "1", // 1, 2, 3
		purchasabilityPreOrderDate: "",
		purchasabilityPreOrderMessage: "",
		purchasabilityCallForPrice: false,
		purchasabilityCallForLabel: "",
	}

	// handle form validations
	const formValidationSchema = Yup.object({
		productName: Yup.string().required('This field is required'),
		SKU: Yup.string().required('This field is required'),
		status: Yup.boolean().required('This field is required'),
		isFeatured: Yup.boolean(),
		costPrice: Yup.string(),
		price: Yup.string().required('This field is required'),
		promoPrice: Yup.string(),
		longDescription: Yup.string(),
		shortDescription: Yup.string(),
		description: Yup.string(),
		stock: Yup.string(),
		lowStock: Yup.string(),
		maxOrderQuantity: Yup.string(),
		minOrderQuantity: Yup.string(),
		weight: Yup.string(),
		width: Yup.string(),
		length: Yup.string(),
		brandId: Yup.string(),
		UPC: Yup.string(),
		height: Yup.string(),
		metaTitle: Yup.string().max(allowedMetaTitleLength, 'The length should not exceed the allowed limit'),
		metaDescription: Yup.string().max(allowedMetaDescLength, 'The length should not exceed the allowed limit'),
		attributes: Yup.array().of(
			Yup.object().shape({
				name: Yup.string().required('This field is required')
			})
		),
		hasRibbon: Yup.boolean(),
		ribbonText: Yup.string().when("hasRibbon", {
			is: true,
			then: Yup.string().required('This field is required')
		}),
		ribbonColor: Yup.string(),
		ribbonDisableDescription: Yup.string(),
		ribbonDisableToCart: Yup.boolean(),
		ribbonPosition: Yup.string(),
		purchasabilityStatus: Yup.string(),
		purchasabilityPreOrderDate: Yup.string().when("purchasabilityStatus", {
			is: "3",
			then: Yup.string().required("This field is required")
		}),
		purchasabilityPreOrderMessage: Yup.string().when("purchasabilityStatus", {
			is: "3",
			then: Yup.string().required("This field is required")
		}),
		purchasabilityCallForPrice: Yup.boolean(),
		purchasabilityCallForLabel: Yup.string().when("purchasabilityStatus", {
			is: "2",
			then: Yup.string().when("purchasabilityCallForPrice", {
				is: true,
				then: Yup.string().required("This field is required")
			})
		}),
	})

	// handle form submmision
	const onProductFormSubmit = values => {
		if (values) {
			// enabling global loading
			setGlobalLoading(true)

			// enabling the button and enabling loading
			setSubmitButtonDisable(true)
			setSubmitButtonLoading(true)

			// saving the data in the database
			const dataToBeSaved = {
				product_name: values.productName,
				sku: values.SKU,
				status: values.status ? 1 : 0,
				is_featured: values.isFeatured ? 1 : 0,
				cost_price: values.costPrice,
				price: values.price,
				promo_price: values.promoPrice,
				categories: categoriesToBeSaved.map(item => {
					return {
						category_id: item.category_id,
						is_default: item.is_default ? 1 : 0
					}
				}), // categories
				brand_id: values.brandId,
				short_description: values.shortDescription,
				long_description: values.longDescription,
				description: values.description,
				stock: values.stock,
				low_stock: values.lowStock,
				max_order_quantity: values.maxOrderQuantity,
				min_order_quantity: values.minOrderQuantity,
				weight: values.weight,
				width: values.width,
				length: values.length,
				height: values.height,
				upc: values.UPC,
				meta_title: values.metaTitle,
				meta_description: values.metaDescription,
				variations: variantMainFields,
				combinations: productCombinations,
				attributes: selectedProductsAttributes,
				ribbon_label: values.ribbonText,
				ribbon_color: values.ribbonColor,
				ribbon_disable_cart: values.ribbonDisableToCart ? 1 : 0,
				ribbon_disable_description: values.ribbonDisableDescription,
				ribbon_position: values.ribbonPosition,
				is_purchasability: values.purchasabilityStatus,
				preorder_message: values.purchasabilityPreOrderMessage,
				preorder_date: values.purchasabilityPreOrderDate,
				call_for_price: values.purchasabilityCallForPrice ? 1 : 0,
				call_for_price_label: values.purchasabilityCallForLabel,
			}

			const headers = {
				"Authorization": `Bearer ${authState.commonToken}`,
				"Api-Token": authState.apiToken,
				"Access-Token": "",
				// "Store-Id": authState.storeId,
			}

			// saving in databse
			addProduct(headers, dataToBeSaved).then(res => {
				// disabling global loading
				setGlobalLoading(false)

				const resData = res.data

				// if request is success
				if (resData.success) {
					// disbling the button loading
					setSubmitButtonLoading(false)

					// scrolling the window to top
					window.scrollTo(0, 0)

					// resetting the form
					formik.resetForm()

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.success(PRODUCT_ADDED_SUCCESSFULLY, {
						autoClose: 2000,
						onClose: () => {
							// redirecting to products
							history.push(storeUrl + '/catalog/products', {
								shouldReload: true
							})
						}
					})
				}

				// if request is not succeed
				if (resData.error) {
					console.log(ERROR_WHILE_CREATING_PRODUCT, res)
					// disbling the button and enabling loading
					setSubmitButtonDisable(false)
					setSubmitButtonLoading(false)

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(ERROR_WHILE_CREATING_PRODUCT, {
						autoClose: 3000,
					})
				}
			}).catch(err => {
				console.log(`${ERROR_WHILE__NAME} addProduct `, err.message)

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => {
						// disabling global loading
						setGlobalLoading(false)

						// disbling the button and enabling loading
						setSubmitButtonDisable(false)
						setSubmitButtonLoading(false)
					}
				})
			})
		}
	}

	// formik hook
	const formik = useFormik({
		initialValues: initialFormValues,
		validationSchema: formValidationSchema,
		onSubmit: onProductFormSubmit,
		enableReinitialize: true
	})

	// getting active tab
	useEffect(() => {
		const hash = window.location.hash

		if (hash) {
			const tab = hash.split('#')
			if (tab[tab.length - 1] === 'variations_tab') {
				// checking if product SKU is not added yet
				if (!formik.getFieldProps('SKU').value) {
					setPageActiveTab("general_tab")
					// window.location.hash = "general_tab"
					// triggering errorrs
					submitBtnRef.current.click()
				} else {
					setPageActiveTab(tab[tab.length - 1])
				}
			} else {
				setPageActiveTab(tab[tab.length - 1])
			}
		} else {
			window.location.hash = '#general_tab'
			setPageActiveTab('general_tab')
		}
	}, [])

	// getting product assentials things
	useEffect(() => {
		const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
		Promise.all([
			getBrands(headers, "limit=-1"),
			getProductsAttributes(headers),
			getCategoriesTree(headers, "parent_id=0&limit=100")
		]).then(res => {
			const response = res;

			if (response?.length) {
				// brands
				(function () {
					const brandsRes = response[0].data
					// console.log("brandsRes ", brandsRes);

					// if request is success
					if (brandsRes.success) {
						setBrands(brandsRes.data)
					}

					// if request is not succeed
					if (brandsRes.error) {
						console.log('Error in brands api!', response)
					}
				})();

				// attributes
				(function () {
					const attributesData = res[1].data

					// disabling the global loading
					setGlobalLoading(false)

					// if request is success
					if (attributesData.success) {
						setProductAttributes(attributesData.data)
					}

					// if request is not succeed
					if (attributesData.error) {
						console.log('Error in attributes api!', response)
					}
				})();

				// categories tree
				(function () {
					const categoriesData = res[2].data
					let defaultCategoriesInComp = defaultCategories?.length ? JSON.parse(defaultCategories) : []

					// disabling the global loading
					setGlobalLoading(false)

					// if request is success
					if (categoriesData.success) {
						// setting all the categories
						setCategories(categoriesData.data)

						// if default category existed in the product details
						if (defaultCategoriesInComp?.length) {
							let generatedData = []
							categoriesData.data.forEach(resItem => {
								defaultCategoriesInComp.forEach(defCatItem => {
									if (resItem.category_id === parseInt(defCatItem.category_id)) {
										const data = resItem
										generatedData.push({
											category_id: data.category_id,
											category_name: data.category_name,
											parent_name: '',
											is_default: defCatItem.is_default
										})
									}

									if (resItem?.sub_categories?.length) {
										resItem.sub_categories.forEach(subCatItem => {
											if (subCatItem.category_id === parseInt(defCatItem.category_id)) {
												const data = subCatItem
												generatedData.push({
													category_id: data.category_id,
													category_name: data.category_name,
													parent_name: resItem.category_name,
													is_default: defCatItem.is_default
												})
											}
										})
									}
								})
							})

							// categories change in component
							setSelectedCategories(generatedData)

							// sending data back to component
							setCategoriesToBeSaved(generatedData)

							// removing category error
							setErrorInCategories(false)
						}
					}

					// if request is not succeed
					if (categoriesData.error) {
						console.log('Error in categories api!', response)
					}
				})();
			}
		}).catch(err => {
			console.log(err)

			// dismissing all the previous toasts first
			toast.dismiss();

			// showing the error message
			toast.error(UNKNOWN_ERROR_OCCURED, {
				autoClose: 2500,
			})
		})

		return () => {
			// canceling get brands api when user leaves the component
			// cancelGetBrandsApi && cancelGetBrandsApi();

			// canceling get categories tree api when user leaves the component
			// cancelGetCategoriesTreeApi && cancelGetCategoriesTreeApi();

			// canceling get attributes api when user leaves the component
			// cancelGetProductsAttributesApi && cancelGetProductsAttributesApi();
		}
	}, [match.params, authState, setGlobalLoading])

	// handle tabs view
	const handleTabView = (ev, tab) => {
		if (tab) {
			// validations
			if (tab === "general_tab") {
				setPageActiveTab("general_tab")
			}

			if (tab === "attributes_tab") {
				setPageActiveTab("attributes_tab")
			}

			if (tab === "variations_tab") {
				// checking if product SKU is not added yet
				if (!formik.getFieldProps('SKU').value) {
					ev.preventDefault()
					setPageActiveTab("general_tab")
					// triggering errorrs
					submitBtnRef.current.click()
				} else {
					setPageActiveTab("variations_tab")
				}
			}

			if (tab === "seo_tab") {
				setPageActiveTab("seo_tab")
			}

			if (tab === "files_tab") {
				setPageActiveTab("files_tab")
			}

			if (tab === "tax_and_shipping_tab") {
				setPageActiveTab("tax_and_shipping_tab")
			}

			if (tab === "purchasability_tab") {
				setPageActiveTab("purchasability_tab")
			}

			if (tab === "related_products_tab") {
				setPageActiveTab("related_products_tab")
			}

			if (tab === "buy_now_tab") {
				setPageActiveTab("buy_now_tab")
			}
		}
	}

	// getting and saving images to be saved
	const getImagesToBeSaved = (imgPath) => {
		if (imgPath) {
			setProductImagesToBeSaved([
				...productImagesToBeSaved,
				imgPath
			])
		}
	}

	// html editor
	const getHTML_editorResultDesc = (data) => {
		console.log("data ", data);
		// setting the description value
		formik.setFieldValue("description", data)
	}

	// show variant page
	const handleVariantPageShow = () => {
		// ev.preventDefault()
		setAddNewVariationViewVisible(true)
	}

	// hide variant page
	const handleVariantPageHide = () => {
		// ev.preventDefault()
		setAddNewVariationViewVisible(false)
	}

	// new variant adding function
	const handleAddNewProductCombinations = (combinations, variations) => {
		if (combinations?.length && variations?.length) {
			console.log("combinations ", combinations);
			console.log("variations ", variations);
			// updating existing combinations
			setProductCombinations(combinations)

			// updating main variant
			setVariantMainFields(variations)

			// setting new combinations
			// setNewProductCombinations([
			// 	...newProductCombinations,
			// 	...combinations
			// ])
		}
	}

	// when submit button gets clicked
	const handleSubmitBtnClick = ev => {
		ev.preventDefault()
		if (categoriesToBeSaved?.length) {
			submitBtnRef.current.click()
		} else {
			setErrorInCategories(true)
		}
	}

	// leave page modal hide
	const onLeavePageModalHide = () => {
		setLeavethePageModalVisibility(false)
	}

	// user leaving modal result
	function confirmPageLeaveAction(bool) {
		// if user selects cancel to leave the page
		if (bool) {
			setLeavethePageModalVisibility(false)
		} else {
			// if user selects to leave the page

			history.push(storeUrl + '/catalog/products/')
		}
	}
	// handle button submission
	const handleBackPress = (ev) => {
		ev.preventDefault()
		setLeavethePageModalVisibility(true)
	}

	return (
		addNewVariationViewVisible ? (
			<React.Fragment>
				<AddNewVariation
					formik={formik}
					variantAllFieldsData={variantAllFieldsData}
					setVariantAllFieldsData={setVariantAllFieldsData}

					handleVariantPageHide={handleVariantPageHide}

					productCombinations={productCombinations}
					variantMainFields={variantMainFields}
					setDeletedVariantMainFields={setDeletedVariantMainFields}
					deletedVariantMainFields={deletedVariantMainFields}

					handleAddNewProductCombinations={(combinations, variations) => handleAddNewProductCombinations(combinations, variations)}
				/>
			</React.Fragment>
		) : (
			<React.Fragment>
				{/* save button */}
				<div id="page-save-button-block" className={`${formik.dirty ? "component-changed" : ""}`}>
					<Container fluid className="st-container">
						<div className="page-save-button-block d-flex align-items-center">
							{/* BACK BUTTON WRAPPER */}
							<div className="back-button-wrapper st-line-height-0">
								{
									formik.dirty ? (
										<a href="/"
											onClick={handleBackPress}
											className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600">
											<FeatherIcon
												icon="arrow-left"
												size="16"
												className="icon me-1" />
											<span>Back to Products</span>
										</a>
									) : (
										<Link to={storeUrl + "/catalog/products/"}
											// onClick={ev => {
											// 	ev.preventDefault()
											// 	history.goBack()
											// }}
											className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600">
											<FeatherIcon
												icon="arrow-left"
												size="16"
												className="icon me-1" />
											<span>Back to Products</span>
										</Link>
									)
								}
							</div>

							{/* save btn */}
							<button
								className={`st-btn st-btn-primary ms-auto ${(submitButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
								disabled={submitButtonDisable || Object.keys(formik.errors).length}
								onClick={ev => handleSubmitBtnClick(ev)}>
								{
									submitButtonLoading ? (
										<Spinner animation="border" size="sm" />
									) : (
										<span>Save</span>
									)
								}
							</button>
						</div>
					</Container>
				</div>

				{/* main components */}
				<section id="app-products__create-product" className="st-def-mar-B">
					<Container fluid className="st-container">
						{/* page content */}
						<div className="app-products__create-product position-relative">

							{/* HEADING WRAPPER */}
							<div className="app-header-wrapper">
								{/* heading */}
								<p className="app-heading text-capitalize">Create Product</p>
								<p className="app-desc">
									Create your product details.
								</p>
							</div>

							{/* page content */}
							<div className="page-content">
								{/* page border box */}
								<div className="page-border-box">
									<div className="pbb-inner">
										{/* page tabs links */}
										<PageTabsLinks
											pageActiveTab={pageActiveTab}
											handleTabView={(ev, tab) => handleTabView(ev, tab)}

											formik={formik}
											errorInCategories={errorInCategories}
										/>

										{/* page form */}
										<form
											onSubmit={formik.handleSubmit}
											noValidate
											autoComplete="off">
											{/* products container */}
											<div className="product-container">
												<div className="pc-inner d-flex flex-wrap">
													{/* PC left sec */}
													<div className="pc-lt media-body">
														<PageLeftView
															pageActiveTab={pageActiveTab}
															formik={formik}

															// GENERAL TAB
															productImages={productImages}
															getImagesToBeSaved={getImagesToBeSaved}

															getDesc={getHTML_editorResultDesc}

															categories={categories}
															selectedCategories={selectedCategories}
															setSelectedCategories={setSelectedCategories}
															defaultCategories={defaultCategories}
															categoriesToBeSaved={categoriesToBeSaved}
															setCategoriesToBeSaved={setCategoriesToBeSaved}
															errorInCategories={errorInCategories}
															setErrorInCategories={setErrorInCategories}

															productAttributes={productAttributes}
															setSelectedProductsAttributes={setSelectedProductsAttributes}
															selectedProductsAttributes={selectedProductsAttributes}

															ribbonColors={ribbonColors}

															// ATTRIBUTES TAB
															brands={brands}

															// VARIATIONS TAB
															productCombinations={productCombinations}
															setProductCombinations={setProductCombinations}
															productCombinationsImages={productCombinationsImages}

															variantMainFields={variantMainFields}

															disabledVariantList={disabledVariantList}
															setDisabledVariantList={setDisabledVariantList}

															handleVariantPageShow={handleVariantPageShow}

															// SEO TAB
															allowedMetaTitleLength={allowedMetaTitleLength}
															allowedMetaDescLength={allowedMetaDescLength}
														/>
													</div>

													{/* PC right sec */}
													<div className="pc-rt">
														<PageRightView
															pageActiveTab={pageActiveTab}

															formik={formik}
														/>
													</div>
												</div>
											</div>

											<button type="submit" hidden ref={submitBtnRef}></button>
										</form>
									</div>
								</div>
								{/* end of page content */}
							</div>
						</div>
					</Container>
				</section>

				{/* modals */}
				<InfoModal
					modalType={"modal_confirm"} // required: type of the modal: modal_confirm && modal_info.
					modalVisibility={leavethePageModalVisibility} // required: determine modal visibility either true or false
					onHide={onLeavePageModalHide} // required to hide the modal

					modalTitle={"Are you sure you want to leave this page?"} // required: show the title
					modalDescription={"You have unsaved changes. All your changes will be lost"} // shows the description

					confirmBtnText={"Stay on the page"} // works only if the modalType is modal_confirm: text for confirm btn. default is "Confirm Action"
					cancelBtnText={"Leave the page"} // works only if the modalType is modal_confirm: text for cancel btn. default is "Confirm Action"
					confirmAction={bool => confirmPageLeaveAction(bool)}
				/>

			</React.Fragment>
		)
	)
}


const getDataFromStore = state => {
	return {
		authState: state.auth,
	};
}

const dispatchActionsToProps = dispatch => {
	return {
		setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
	}
}

export default connect(getDataFromStore, dispatchActionsToProps)(CreateProduct)